module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "OfficeAdd"
  }, [_c('div', {
    staticClass: "header header-mobile"
  }, [_c('aside', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle active"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.add.tabs.address.title))])]), _vm._v(" "), _c('aside', {
    staticClass: "navigation"
  }), _vm._v(" "), _c('aside', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    class: {
      active: _vm.steps.two.active
    }
  }), _vm._v(" "), _c('span', {
    class: {
      active: _vm.steps.two.active
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.add.tabs.specialities.title))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.steps.one.active) ? _c('div', [_c('header', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.translate.pages.office.add.tabs.address.title))])]), _vm._v(" "), _c('main', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.name.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.name))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.data.name = $$v
      },
      expression: "data.name"
    }
  }), _vm._v(" "), (_vm.errors.name.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.name.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.street.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.street))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.street),
      callback: function($$v) {
        _vm.data.street = $$v
      },
      expression: "data.street"
    }
  }), _vm._v(" "), (_vm.errors.street.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.street.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.number.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.number))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.number),
      callback: function($$v) {
        _vm.data.number = $$v
      },
      expression: "data.number"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua"
  }, [_vm._v("ej: 1234")]), _vm._v(" "), (_vm.errors.number.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.number.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.errors.region_id.invalid
    },
    staticStyle: {
      "margin-bottom": "27px !important"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('vue-select', {
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.regions,
      "placeholder": _vm.placeholder_provincia,
      "on-change": _vm.changeRegion
    },
    model: {
      value: (_vm.data.region.label),
      callback: function($$v) {
        _vm.data.region.label = $$v
      },
      expression: "data.region.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), (_vm.errors.region_id.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.region_id.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container masked_input",
    class: {
      'md-input-invalid': _vm.errors.comunity.invalid
    },
    staticStyle: {
      "margin-bottom": "27px !important"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('vue-select', {
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.comunities,
      "placeholder": "Comuna",
      "on-change": _vm.changeCity
    },
    model: {
      value: (_vm.data.city.label),
      callback: function($$v) {
        _vm.data.city.label = $$v
      },
      expression: "data.city.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), (_vm.errors.comunity.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.comunity.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.phone.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.phone))]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "text",
      "data-vv-rules": "required|numeric|min:6|max:12"
    },
    model: {
      value: (_vm.data.phone),
      callback: function($$v) {
        _vm.data.phone = $$v
      },
      expression: "data.phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marcaagua"
  }, [_vm._v("ej: 912345")]), _vm._v(" "), (_vm.errors.phone.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.phone.msg))]) : _vm._e()], 1)], 1)], 1)], 1)]) : _c('div', [_c('header', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.translate.pages.office.add.tabs.specialities.title))])]), _vm._v(" "), _c('main', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('div', {
    staticClass: "multiple checkbox-list",
    class: {
      'error': _vm.errors.speciality.invalid
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.specialities))]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, _vm._l((_vm.specialities), function(speciality) {
    return _c('md-checkbox', {
      key: speciality.id,
      staticClass: "option text--color",
      on: {
        "change": function($event) {
          _vm.onChosen($event, speciality.id)
        }
      },
      model: {
        value: (speciality.checked),
        callback: function($$v) {
          speciality.checked = $$v
        },
        expression: "speciality.checked"
      }
    }, [_vm._v(_vm._s(speciality.name))])
  }))]), _vm._v(" "), _c('label', {
    staticClass: "subtitle",
    class: {
      'error': _vm.errors.speciality.invalid
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.selects_specialties))])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container h10",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.duration.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.duration))]), _vm._v(" "), _c('md-select', {
    model: {
      value: (_vm.data.duration),
      callback: function($$v) {
        _vm.data.duration = $$v
      },
      expression: "data.duration"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("60")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "70"
    }
  }, [_vm._v("70")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "80"
    }
  }, [_vm._v("80")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("90")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "110"
    }
  }, [_vm._v("110")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v("120")])], 1), _vm._v(" "), (_vm.errors.duration.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.duration.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hour_confirm.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.add.fields.hour_confirm))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.hour_confirm),
      callback: function($$v) {
        _vm.data.hour_confirm = $$v
      },
      expression: "data.hour_confirm"
    }
  }), _vm._v(" "), _c('md-select', {
    model: {
      value: (_vm.data.hour_confirm),
      callback: function($$v) {
        _vm.data.hour_confirm = $$v
      },
      expression: "data.hour_confirm"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "36"
    }
  }, [_vm._v("36")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v("48")])], 1), _vm._v(" "), (_vm.errors.hour_confirm.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hour_confirm.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    staticStyle: {
      "padding": "1.25em"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "100"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary text--color",
    attrs: {
      "md-theme": "green"
    },
    model: {
      value: (_vm.data.add_user),
      callback: function($$v) {
        _vm.data.add_user = $$v
      },
      expression: "data.add_user"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.translate.pages.office.add.fields.add_user) + "\n                        ")])], 1)], 1)], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "content-footer"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "buttons clearfix"
  }, [_c('div', {
    staticClass: "return"
  }, [(_vm.steps.button) ? _c('router-link', {
    staticClass: "md-button md-raised md-size btn--gray masked_btn",
    attrs: {
      "to": {
        name: 'Office'
      }
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" " + _vm._s(_vm.translate.actions.previous))], 1) : _vm._e(), _vm._v(" "), (!_vm.steps.button) ? _c('md-button', {
    staticClass: "md-raised md-size btn--gray",
    nativeOn: {
      "click": function($event) {
        _vm.previous($event)
      }
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" " + _vm._s(_vm.translate.actions.previous))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-size btn--blue",
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.actions.next) + " "), _c('md-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-204f87d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Office/Add.vue
// module id = 660
// module chunks = 1